import { render } from "./testApi.vue?vue&type=template&id=7560d042"
import script from "./testApi.vue?vue&type=script&lang=js"
export * from "./testApi.vue?vue&type=script&lang=js"

import "./testApi.vue?vue&type=style&index=0&id=7560d042&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__